module.exports = __webpack_public_path__ + "img/telescope1.33a337b3.svg";